




























import { defineComponent } from '@vue/composition-api'
import { Dropdown, DropdownItem, DropdownMenu } from 'element-ui'
import { KisweIcon } from '@/modules/kisweui/components'
import { localeInfo, SupportedLocale } from '@/plugins/translations/types'
import useLocale from '@/compositions/locale'
import './LanguageSelector.scss'
import { KeyDict } from '@/types'

interface LanguageOption {
  flag: string,
  language: SupportedLocale,
  title: string
}

export default defineComponent({
  name: 'LanguageSelector',
  components: {
    KisweIcon,
    'el-dropdown': Dropdown,
    'el-dropdown-menu': DropdownMenu,
    'el-dropdown-item': DropdownItem
  },
  props: {
    customStyles: {
      type: Object as () => KeyDict<string>,
      required: false,
      default: () => ({})
    }
  },
  setup: () => ({
    ...useLocale()
  }),
  computed: {
    languages (): LanguageOption[] {
      const languages: LanguageOption[] = []
      for (const language of Object.values(SupportedLocale)) {
        const localInfo = localeInfo[language]
        languages.push({ flag: localInfo.flag, language, title: localInfo.title })
      }
      return languages
    },
    currentLocaleTitle (): string {
      return localeInfo[this.currentLocale].title
    }
  }
})
